import { createContext, Dispatch, SetStateAction, useState, FC, useMemo } from 'react';

import useContextWithWithError from 'hooks/useContextWithErrorWrapper';

export enum ViewType {
    EDIT = 'EDIT',
    READ = 'READ',
}

type UserProfileViewContextType =
    | {
          viewType: ViewType;
          setViewType: Dispatch<SetStateAction<ViewType>>;
          modalView: boolean;
      }
    | undefined;

const UserProfileViewContext = createContext<UserProfileViewContextType>(undefined);

export const UserProfileViewProvider: FC<{ modalView?: boolean }> = ({ modalView, children }) => {
    const [viewType, setViewType] = useState<ViewType>(ViewType.READ);

    const profileViewCtx = useMemo(
        () => ({ viewType, setViewType, modalView }),
        [viewType, modalView]
    );

    return (
        <UserProfileViewContext.Provider value={profileViewCtx}>
            {children}
        </UserProfileViewContext.Provider>
    );
};

export const useUserProfileViewContext = () =>
    useContextWithWithError(UserProfileViewContext, 'UserProfileViewContext');
